import React from 'react'
import { Skeleton, Typography, Box } from '@mui/material'
import ButtonSelect from './ButtonSelect'

const ListButton = ({ isLoading, data = [], onClick, module, selectedId, cols = 3 }) => {
  return (
    <>
      <Typography
        variant='caption'
        className='uppercase '
        sx={{ color: '#7c828d', fontWeight: 600, fontSize: '0.7rem' }}
      >
        {module}
      </Typography>
      {isLoading ? (
        <Box className='flex gap-2 items-center pb-2'>
          {Array.from({ length: cols }).map((_, i) => (
            <Skeleton key={i} width={160} height={40} />
          ))}
        </Box>
      ) : data?.length > 0 ? (
        <Box className='flex flex-wrap gap-2 items-center pb-2'>
          {data?.map((el, i) => (
            <ButtonSelect
              key={i}
              data={el}
              text={el.code || el.name || el.title || el._id}
              isSelected={selectedId === el._id}
              onClick={() => onClick(el)}
              type={module}
            />
          ))}
        </Box>
      ) : (
        <Box className='flex gap-2 items-center pb-2'>
          <Typography color='textSecondary'>No {module} available yet</Typography>
        </Box>
      )}
    </>
  )
}

export default ListButton
